import React, { useContext } from 'react';
import { ThemeContext } from '../../App';
import { Jumbotron } from './migration';
import { motion } from 'framer-motion';

const AboutMe = ({ heading, message, link, imgSize, resume }) => {
  const { theme } = useContext(ThemeContext);
  const buttonClass = `btn btn-lg ${theme === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`;

  return (
    <Jumbotron id="aboutme" className="aboutme jumbotron jumbotron-fluid m-0">
      <div className="container container-fluid py-5">
        <div className="row align-items-center">
          <motion.div
            className="col-lg-5 col-md-5 d-lg-block align-self-center text-center mb-4 mb-lg-0"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
          >
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
              style={{ display: 'inline-block' }}
            >
              <img
                className="img-fluid rounded-circle"
                src={link}
                alt="profilepicture"
                width={imgSize}
                height={imgSize}
                style={{
                  border: '4px solid var(--border-color)',
                  boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease'
                }}
              />
            </motion.div>
          </motion.div>
          
          <motion.div
            className="col-lg-7"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.45, delay: 0.1, ease: [0.4, 0, 0.2, 1] }}
          >
            <motion.h2
              className="display-4 mb-5 text-center"
              style={{ fontWeight: 700, color: 'var(--text-primary)' }}
            >
              {heading}
            </motion.h2>
            <motion.p
              className="lead text-center"
              style={{ 
                color: 'var(--text-secondary)',
                lineHeight: '1.8',
                fontSize: '1.1rem'
              }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              {message}
            </motion.p>
            {resume && (
              <motion.p
                className="lead text-center mt-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
              >
                <motion.a
                  className={buttonClass}
                  href={resume}
                  target="_blank"
                  rel="noreferrer noopener"
                  role="button"
                  aria-label="Resume/CV"
                  whileHover={{ 
                    scale: 1.02,
                    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)"
                  }}
                  whileTap={{ scale: 0.97 }}
                  style={{
                    borderRadius: '12px',
                    borderWidth: '2px',
                    fontWeight: 600,
                    padding: '0.75rem 2rem',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Resume
                </motion.a>
              </motion.p>
            )}
          </motion.div>
        </div>
      </div>
    </Jumbotron>
  );
};

export default AboutMe;
